// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MeetingLinkPopup__popup-d54a75 {
  flex: none;
}

.MeetingLinkPopup__popupHeader-da4d5f {
  border: none;
}

.MeetingLinkPopup__container-bd7bfb {
  display: flex;
  flex-direction: column;
  padding: 0px 24px 12px;
}

.MeetingLinkPopup__popupFooter-a9ae73 {
  justify-content: left;
  padding: 0;
}

.MeetingLinkPopup__title-ec8616 {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--base-110);
  margin-bottom: 12px;
}

.MeetingLinkPopup__text-e1b271 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}

.MeetingLinkPopup__clipboard-eea50c {
  flex-grow: 1;
}

.MeetingLinkPopup__actions-dd251e {
  display: flex;
  gap: 12px;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MeetingLinkPopup/MeetingLinkPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,UAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AACF","sourcesContent":[".popup {\n  flex: none;\n}\n\n.popupHeader {\n  border: none;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  padding: 0px 24px 12px;\n}\n\n.popupFooter {\n  justify-content: left;\n  padding: 0;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--base-110);\n  margin-bottom: 12px;\n}\n\n.text {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n\n.clipboard {\n  flex-grow: 1;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `MeetingLinkPopup__popup-d54a75`,
	"popupHeader": `MeetingLinkPopup__popupHeader-da4d5f`,
	"container": `MeetingLinkPopup__container-bd7bfb`,
	"popupFooter": `MeetingLinkPopup__popupFooter-a9ae73`,
	"title": `MeetingLinkPopup__title-ec8616`,
	"text": `MeetingLinkPopup__text-e1b271`,
	"clipboard": `MeetingLinkPopup__clipboard-eea50c`,
	"actions": `MeetingLinkPopup__actions-dd251e`
};
module.exports = ___CSS_LOADER_EXPORT___;
